export interface CampaignChannel {
  id: number;
  campaignId?: number;
  channelId?: number;
  channelUID?: string;
  campaignTitle?: string;
  productionId?: string;
  clientId?: number;
  lang?: string;
  schedule?: ScheduleDTO;
  channelType?: ChannelType;
  site?: unknown;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
  playerVersion?: string;
  isSEO?: boolean;
  integrationTags?: IntegrationTags;
  smartUrlLink: string; // not documented, but always there
  minisiteUrl?: string; // not documented
  optins?: OptinLinkedDTO[];
  oembed?: {
    url: string;
  };
}

export interface HourlyLimitationDTO {
  startTime: string;
  endTime: string;
}

export interface IntegrationTags {
  MEASUREMENTS?: unknown;
  WIDGET?: WidgetIntegration;
  MINI_SITE?: MiniSiteIntegration;
  FACEBOOK?: unknown;
  INTEGRATION_ID?: number;
}

export enum ChannelType {
  WIDGET = 'WIDGET', // = iframe
  MINI_SITE = 'MINI_SITE',
  FACEBOOK = 'FACEBOOK',
  MOBILE = 'MOBILE',
  PROMO_FOOTER = 'PROMO_FOOTER',
  PROMO_POPUP = 'PROMO_POPUP',
  NONE = 'NONE',
}

export interface WidgetIntegration {
  JAVASCRIPT: TagIntegration;
  AMP: TagIntegration;
  FBIA: TagIntegration;
  HTML: TagIntegration;
  WEBVIEW: TagIntegration;
  MINI_SITE: MiniSiteIntegration;
  FACEBOOK: FacebookIntegration;
  SMART_URL: string;
}

export interface MiniSiteIntegration {
  link: string;
  smartLink: string;
}

export interface FacebookIntegration {
  link: string;
}

export interface OptinLinkedDTO {
  id: number;
  label: string;
  campaignId: number;
  state: OptinState;
  selected: boolean;
  idSite: number;
  idChannel: number;
}

export enum OptinState {
  available = 'available',
  mandatory = 'mandatory',
  'pre-selected' = 'pre-selected',
}

export interface TagIntegration {
  tag: string;
  script?: string;
}

export interface ScheduleDTO {
  startDate: string;
  endDate: string;
  hourlyLimitation: boolean | HourlyLimitationDTO;
}
